import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import GoogleIconSVG from './google.js';
import styles from './GoogleIcon.module.scss.js';

var GoogleIcon = function GoogleIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles['whiteBackground'], className)
  }, /*#__PURE__*/React.createElement(GoogleIconSVG, null));
};
GoogleIcon.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export { GoogleIcon as default };
//# sourceMappingURL=index.js.map
